import { Injectable } from '@angular/core';
import { ParkingsService } from './parkings.service';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

@Injectable()
export class ParkingResolverService {

  constructor(private parkingService: ParkingsService) { }

  resolve(route: ActivatedRouteSnapshot) {
    return Number(route.params['id']);
    // if (this.parkingService.loadedParking != null && this.parkingService.loadedParking.parkingID == id) {
    //   return this.parkingService.loadedParking;
    // } else {
    //   return this.parkingService.getParking(id);
    // }
    // return this.parkingService.getParking(id);
  }
}
